module.exports = __webpack_public_path__ + "img/hes-soin-infir.234373c1.jpg";